export default {
    methods: {
        validationNotification(errors) {
            if (errors) {
                this.$store.dispatch('modalNotificationMessageOpen', ['Форма содержит ошибки'])
                return false
            } else {
                this.$store.dispatch('modalNotificationMessageClose')
                return true
            }
        }
    }
}